import { Activity } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'

const ActionsFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const actionOptions: ComboboxFilterOption<string>[] = [
    { value: 'create', label: 'Create' },
    { value: 'update', label: 'Update' },
    { value: 'destroy', label: 'Destroy' },
  ]

  const filteredOptions = actionOptions.filter(
    (option) =>
      (option.label || '').toLowerCase().includes(query.toLowerCase()) ||
      option.value.toLowerCase().includes(query.toLowerCase())
  )

  return (
    <ComboboxMultiSelectFilter
      {...props}
      options={[{ groupLabel: 'Actions', options: filteredOptions }]}
      placeholder='Search actions to filter...'
      onValueChange={setQuery}
    >
      <FilterManagementDropdown
        {...props}
        options={actionOptions}
        noSelectionText='Actions'
        pluralIdentifier='actions'
      >
        <Activity size={20} />
      </FilterManagementDropdown>
    </ComboboxMultiSelectFilter>
  )
}

export default ActionsFilter
